import { parseAsset } from '../assets/utils.ts'
import { type RawEvent } from './types.ts'

export function parseEvent(event: RawEvent | null) {
  if (!event) {
    return null
  }

  return {
    ...event,
    asset: (event.asset ? parseAsset(event.asset) : undefined) ?? undefined,
    contacts: event.event_contacts
      ?.map((eventContact) => eventContact.contact)
      .filter((contact) => contact !== null),
  }
}
